<template lang="pug">
 .orientationChange
  img(src="@/assets/img/orientation_change.gif" alt="")
  h3 Поверните телефон
</template>

<script>
  export default {
    name: "OrientationChangePopup"
  }
</script>

<style lang="scss" scoped>
  .orientationChange {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000000;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4vh;
    background: url(../../assets/img/orientation_change_bg.jpg) no-repeat 0 0/cover;

    img {
      height: 44vh;
    }

    h3 {
      font-size: 4.5vh;
      letter-spacing: .05vh;
      color: #fff;
    }
  }

  @media screen and (orientation: landscape) {
    .mobile .orientationChange {
      display: flex;
    }
  }
</style>